import React, { useState, useEffect } from "react";
import { Route } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { InteractionStatus, InteractionType } from "@azure/msal-browser";

export const RouteGuard = ({ Component, ...props }) => {

    const { instance , accounts, inProgress} = useMsal();
    const [isAuthorized, setIsAuthorized] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const checkAuthorization = () => {
            // Reset states
            setIsAuthorized(false);
            setIsLoading(true);

            // Wait for authentication to complete
            if (inProgress !== InteractionStatus.None) {
                setIsLoading(true);
                return;
            }

            // Check if user is authenticated
            if (!accounts || accounts.length === 0) {
                setIsLoading(false);
                setIsAuthorized(false);
                return;
            }

            const currentAccount = instance.getActiveAccount();
            
            // Check if user has required roles
            if (currentAccount && currentAccount.idTokenClaims && currentAccount.idTokenClaims['roles']) {
                const userRoles = currentAccount.idTokenClaims['roles'];
                const requiredRoles = props.roles || [];
                
                // Check if user has any of the required roles
                const hasRequiredRole = requiredRoles.some(role => userRoles.includes(role));
                
                console.log('RouteGuard Authorization Check:');
                console.log('Required roles:', requiredRoles);
                console.log('User roles:', userRoles);
                console.log('Has required role:', hasRequiredRole);
                
                setIsAuthorized(hasRequiredRole);
            } else {
                setIsAuthorized(false);
            }
            
            setIsLoading(false);
        };

        checkAuthorization();
    }, [instance, accounts, inProgress, props.roles]);


    return (
        <>
            {isLoading ? (
                <div className="data-area-div">
                    <h3>Loading...</h3>
                </div>
            ) : isAuthorized ? (
                <Route {...props} render={routeProps => <Component {...routeProps} />} />
            ) : (
                <div className="data-area-div">
                    <h3>You are unauthorized to view this content.</h3>
                </div>
            )}
        </>
    );
};